module.exports = __webpack_public_path__ + "img/usb_100.16b4ab65.png";